<div class="full-screen d-flex align-items-center pt-30 pb-30 pt-lg-0 pb-lg-0">
    <div class="container-fluid">
        <div class="row justify-content-lg-start justify-content-center">
            <div class="col-lg-2 d-none d-lg-block"></div>
            <div class="col-12 col-lg-10">
                <div class="brk-form brk-form-strict maxw-570 mx-auto mx-lg-0 text-center text-lg-left"
                    data-brk-library="component__form">

                    <h1
                        class="font__family-montserrat font__weight-bold font__size-42 line__height-42 mt-0 mb-35 text-center text-lg-left">
                        Eleição solicitada não encontrada!</h1>
                    <div class="not-found-illustration mb-30 text-center text-lg-left" aria-hidden="true">
                        <svg viewBox="0 0 420 250" role="img" class="not-found-illustration__svg">
                            <defs>
                                <linearGradient id="skyGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#f7fbf4"></stop>
                                    <stop offset="55%" stop-color="#e6f0df"></stop>
                                    <stop offset="100%" stop-color="#d5e6cc"></stop>
                                </linearGradient>
                                <linearGradient id="groundGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#dbe8d3"></stop>
                                    <stop offset="100%" stop-color="#bfd2b2"></stop>
                                </linearGradient>
                                <linearGradient id="roadGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#7d8978"></stop>
                                    <stop offset="100%" stop-color="#4a5347"></stop>
                                </linearGradient>
                                <linearGradient id="hillGradient" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0%" stop-color="#c8dcbf"></stop>
                                    <stop offset="100%" stop-color="#9fbc93"></stop>
                                </linearGradient>
                                <clipPath id="sceneClip">
                                    <rect x="0" y="0" width="420" height="250" rx="24"></rect>
                                </clipPath>
                            </defs>
                            <g clip-path="url(#sceneClip)">
                                <rect x="0" y="0" width="420" height="250" rx="24" fill="url(#skyGradient)"></rect>
                                <circle cx="302" cy="62" r="24" fill="#f5f0c3" opacity="0.95"></circle>
                                <path d="M0 148C56 130 89 126 143 134C193 142 239 126 290 120C340 114 381 122 420 142V250H0Z"
                                    fill="url(#groundGradient)"></path>
                                <path d="M0 166C51 146 87 144 137 152C193 161 245 146 293 141C347 135 381 145 420 162V250H0Z"
                                    fill="url(#hillGradient)" opacity="0.9"></path>
                                <path d="M210 144 C184 170 145 222 87 250 H333 C275 222 236 170 210 144Z"
                                    fill="url(#roadGradient)"></path>
                                <path d="M209 148 H211 L226 250 H194Z" fill="#f5f0c3" opacity="0.9"></path>
                                <path d="M87 250 C145 222 184 170 210 144" stroke="white" stroke-width="4"
                                    stroke-linecap="round" fill="none" opacity="0.6"></path>
                                <path d="M333 250 C275 222 236 170 210 144" stroke="#f7faf5" stroke-width="4"
                                    stroke-linecap="round" fill="none" opacity="0.6"></path>
                                <path d="M197 136C201 132 205 129 210 129C215 129 219 132 223 136" stroke="#7c9a72"
                                    stroke-width="4" stroke-linecap="round" fill="none"></path>
                                <circle cx="210" cy="127" r="5" fill="#7c9a72"></circle>
                                <path d="M73 188C93 182 106 183 123 190" stroke="#88a57d" stroke-width="5"
                                    stroke-linecap="round" fill="none" opacity="0.7"></path>
                                <path d="M298 184C321 176 339 177 357 186" stroke="#88a57d" stroke-width="5"
                                    stroke-linecap="round" fill="none" opacity="0.7"></path>
                            </g>
                        </svg>
                    </div>
                    <div class="alert alert-clean fade alert-warning text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
                        role="alert" data-brk-library="component__alert">
                        <i class="start-icon far fa-exclamation-triangle"></i>
                        <strong class="font__weight-semibold">Não foi possível localizar a eleição.</strong>
                        Verifique o link informado e tente novamente. Se o problema persistir, solicite um novo acesso
                        ao responsável pela eleição.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>